import {Transcriber} from './transcriber.js';

export class TranscriberDescription extends Transcriber {
	constructor(component_key) {
		super(component_key);
		this.tracking_section = 'description';
	}

	init() {
		super.init();
		if (!this.is_supported() || !this._language_matches()) {
			this.$root.remove();
			return;
		}
		this.$textarea = jQuery('.js-mpaf_description_textarea');
		this.$start_btn = this.$root.find('.js-transcriber_start');
		this.$stop_btn = this.$root.find('.js-transcriber_stop');
		this.$stop_float = this.$root.find('.js-transcriber_stop_floating');
		this.$stop_float.detach().appendTo(this.$textarea.closest('.js-mpaf_description_textarea_container'));
		this.$mic = this.$root.find('.js-transcriber_mic');
		this.$start_btn.on('click', () => this.start_dictation());
		this.$stop_btn.on('click', () => this.stop_dictation());
		this.$stop_float.on('click', () => this.stop_dictation());
		this.$mic.on('click', () => {
			this.is_recording ? this.stop_dictation() : this.start_dictation();
		});
		this._viewport_initial_height = window.visualViewport
			? window.visualViewport.height
			: window.innerHeight;
		this._bind_cursor_tracking(this.$textarea);
		this._init_viewport_detection();
	}

	_init_viewport_detection() {
		if (window.visualViewport) {
			window.visualViewport.addEventListener('resize', this._handle_viewport_change.bind(this));
			window.visualViewport.addEventListener('scroll', this._handle_viewport_change.bind(this));
		}
	}

	_handle_viewport_change() {
		if (!this.is_recording) {
			return;
		}
		const current = window.visualViewport
			? window.visualViewport.height
			: window.innerHeight;
		if (current < this._viewport_initial_height) {
			this.$stop_float.removeClass('hidden');
		} else {
			this.$stop_float.addClass('hidden');
		}
	}

	start_dictation() {
		// the field is readonly while the AI generates; dictation writes into it
		// programmatically and would ignore that (DEV-18209)
		if (this.$textarea.prop('readonly')) {
			return;
		}
		super.start_dictation();
	}

	get_selection_start() {
		return this.$textarea[0].selectionStart || 0;
	}

	get_selection_end() {
		return this.$textarea[0].selectionEnd || 0;
	}

	set_cursor_position(pos) {
		const el = this.$textarea[0];
		el.selectionStart = el.selectionEnd = pos;
	}

	get_textarea_value() {
		return this.$textarea.val();
	}

	set_textarea_value(val) {
		this.setting_value = true;
		this.$textarea.val(val).trigger('input');
		this.setting_value = false;
	}

	get_max_length() {
		return parseInt(this.$textarea.attr("maxlength")) || 0;
	}

	focus_textarea() {
		this.$textarea.focus();
	}
}

